module.exports = ".glyphicon-arrow-right {\n    font-size: 27px;\n    padding-top: 25px !important\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal/mapa-layout-modal/mapa-layout-modal.component.css
// module id = ./src/app/modal/mapa-layout-modal/mapa-layout-modal.component.css
// module chunks = main